import script from "./StructuredAdminPrayerList.vue?vue&type=script&setup=true&lang=js"
export * from "./StructuredAdminPrayerList.vue?vue&type=script&setup=true&lang=js"

import "./StructuredAdminPrayerList.vue?vue&type=style&index=0&id=0ab7b516&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ab7b516"]])

export default __exports__